import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { fetchQualityAlertWithFilters } from './store/slice';
import { actions as qualityAlertActions } from './store/slice';
import QualityAlertModals from './quality-alert-modals';
import QualityAlertContent from './quality-alert-content';
import QualityAlertTopHead from './quality-alert-top-head';
import { fetchAllProcessStatuses } from '../../core/redux/status/slice';
import { showModal } from '../../core/redux/main/slice';
import { MODAL_TYPES } from '../components/app-modals';
import { parseQualityAlertDeepLink } from './quality-alert-deep-link';

const { resetFilters, setFilterVisible } = qualityAlertActions;
const { QUALITYALERT_ADD_EDIT } = MODAL_TYPES;

const QualityAlertView = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const openedDeepLinkKeyRef = useRef(null);

  useEffect(() => {
    dispatch(fetchQualityAlertWithFilters());
    dispatch(fetchAllProcessStatuses());
    return () => {
      dispatch(resetFilters());
      dispatch(setFilterVisible(false));
    };
  }, []);

  useEffect(() => {
    const deepLink = parseQualityAlertDeepLink(location.search);
    if (!deepLink) {
      openedDeepLinkKeyRef.current = null;
      return undefined;
    }

    const key = `${deepLink.partId}:${deepLink.alertId || ''}`;
    if (openedDeepLinkKeyRef.current === key) {
      return undefined;
    }

    // Open immediately — the modal loads the part's alerts. Waiting on a fetch
    // first was cancelled by React Strict Mode and left users on the tile page.
    dispatch(
      showModal(QUALITYALERT_ADD_EDIT, {
        id: deepLink.partId,
        alertId: deepLink.alertId,
        isReadOnly: true,
      }),
    );
    openedDeepLinkKeyRef.current = key;
    return undefined;
  }, [dispatch, location.search]);
  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Quality Alert</h4>
              </div>
            </div>
            <QualityAlertTopHead />
          </div>
          <QualityAlertContent />
          <QualityAlertModals />
        </div>
      </div>
    </div>
  );
};

export default QualityAlertView;
